<script>
import Str from "helpers/Str";
export default {
  props: {
    options: { type: Object },
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    title() {
      return _.has(this.options, "title") ? this.options.title : "";
    },
  },
  methods: {
    resolve(response, stayOpen = false) {
      response = response || null;
      this.$emit("resolve", response);
      if (!stayOpen) { 
          $("#" + this.id).modal("hide");
      }
    },
    close() {
      this.$emit("close");
      $("#" + this.id).modal("hide");
      $(".modal-backdrop").first().remove();
    },
  },
  mounted() {
    this.id = this.id || Str.random(10);
    this.$nextTick(() => {
      $("#" + this.id).modal({ backdrop: "static" });
      $("#" + this.id).on("hidden.bs.modal", (e) => {
        this.$root.modal = null;
      });
    });
  },
};
</script>